import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { RemoveCircleAlternate as Svg } from './svgs/RemoveCircleAlternate.svg';

export const RemoveCircleAlternate = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
